import styled from 'styled-components'
import { layout } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { Flex, Text } from 'Components/UI'

import { PX_BLUEPRINT } from 'Constants/Landing'

export const Container = styled(Flex)`
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-self: center;
  position: relative;
`

export const Wrapper = styled(Flex).attrs({
  pr: [0, 0, 24, 24, 32],
})`
  flex-direction: column;
  position: relative;
`

export const StepText = styled(Text).attrs({
  fontSize: [16, 16, 20],
  ml: [4, 4, 7, 9, 12],
})`
  font-weight: 700;
  line-height: 125%;
`

export const Description = styled(Text).attrs({
  fontSize: [14, 14, 14, 14, 16],
  as: 'div',
})`
  color: ${themeGet('colors.calculator.textSecondary')};
  font-weight: 400;
  line-height: 24px;
`

const Hider = styled(Flex).attrs({
  left: [0 - PX_BLUEPRINT[0], 0],
})`
  width: 12px;
  top: 16px;
  position: absolute;
  z-index: 9;

  background-color: ${themeGet('colors.white')};
`
export const HiderTop = styled(Hider).attrs({
  height: [100, 100, 200],
})`
  transform: translateX(-50%) translateY(-100%);
`

export const HiderBottom = styled(Hider).attrs({
  height: [100, 100, 300, 345, 380],
})`
  transform: translateX(-50%);
`

export const PathHolder = styled.div.attrs({
  display: ['none', 'none', 'flex'],
})`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  display: flex;
  overflow: hidden;
  width: 3px;

  ${layout}
`
